import React from "react";
import { Route } from "react-router-dom";
import { useRecoilValue, useSetRecoilState } from "recoil";
import { errorState } from "../recoil/error/atom";
import { modalState } from "../recoil/modal/atom";
import { toastMessageState } from "../recoil/toast/atom";
import ErrorHandler from "../components/common/ErrorHandler";
import ModalComponent from "../components/common/ModalComponent";
import { ToastHandler } from "@qjumpers/common-ui";
import App from "../containers/App";
import ErrorBoundary from "../ErrorBoundary";

const PrivateRoutes = () => {
  const popError = useSetRecoilState(errorState);
  const error = useRecoilValue(errorState);
  const modal = useRecoilValue(modalState);
  const toast = useRecoilValue(toastMessageState);
  const setToast = useSetRecoilState(toastMessageState);
  const clearToastMessage = () => {
    setToast([]);
  };
  return (
    <ErrorBoundary popError={popError}>
      <ErrorHandler errors={error} />
      <ModalComponent modalData={modal} />
      <ToastHandler toast={toast} clearToasts={clearToastMessage} />
      <Route path="/" component={App}></Route>
    </ErrorBoundary>
  );
};

export default PrivateRoutes;
